module.exports = __webpack_public_path__ + "img/02.9eb4853e.jpg";